import { PageData } from 'api/Pagination/Types'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'

import {
  CampaignResultsExportItem,
  CampaignResultsItem,
  CampaignResultsProvider,
  FetchParams,
} from './CampaignResultsProvider'

export class MarginBonusResultsProvider implements CampaignResultsProvider {
  supportsSort = false

  constructor(
    private api: TradingAccountsApiClient,
    private campaignId: string
  ) {}

  async fetch(params: FetchParams): Promise<PageData<CampaignResultsItem[]>> {
    const { sort, ...restParams } = params
    return this.api.getMarginBonusResults(this.campaignId, restParams)
  }

  mapExport(items: CampaignResultsItem[]): CampaignResultsExportItem[] {
    return items as CampaignResultsExportItem[]
  }
}
